import { z } from 'zod';
import { $getPaginationResponseType } from '@shared/types';
import { $CandidateResume } from './CandidateResume';

export const $CandidateResumeSummary = $CandidateResume
  .pick({
    resumeId: true,
    salary: true,
    desiredJob: true,
    experience: true,
    employmentDate: true,
    is_active: true,
    createdAt: true,
    updatedAt: true,
    currency: true,
    employmentTypes: true,
    scheduleWorks: true,
  })
  .extend({
    createdAt: z.string().nullable(),
  });

export const $CandidateResumeListResponse = $getPaginationResponseType(
  $CandidateResumeSummary
);
